/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import React, { Ref } from 'react';
import styles from '../index.css';
import classNames from 'classnames';
import SlideListCell from '../cell/index';
import connect from '@src/js/separate-logic/connect';
import CellWrapperPresenter from './cell-wrapper-presenter';
import CellWrapperModel from './cell-wrapper-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import type { IRenderClearanceOptions } from '..';
import { IReactionDisposer, reaction } from 'mobx';

// 1.声明props类型
interface IListCellProps{
    // model props
    slideClearanceIndex: number,

    // presenter props
    setRef: (name: string, ref: any) => void,
    getHistoryColor: () => string,

    // 父组件props
    slideWidth: number,
    slideHeight: number,
    slideInnerHeight: number,
    slideModel: any,
    isSelected: boolean,
    cellIndex: number,
    handleMouseEnter: (e, index: number) => void,
    handleMouseLeave: (e, index: number) => void,
    handleMouseDown: (e, index: number, id: ISlideModel) => void,
    handleLeftClick: (e, index: number, id: ISlideModel) => void,
    shouldUpdate: boolean,
    lockInfo: any,
    draging: boolean,
    motionStyle: any,
    currentDragIndex: number,
    extraClass: string
    renderCellIndex: number;
    clearanceIndex: number;
    renderClearanceOrDragIndicator: (options: IRenderClearanceOptions) => React.ReactElement;
}

/**
 * Cell wrapper，显示Clearance和cell
 */
export class SlideCellWrapper extends React.Component<IListCellProps> {
    public static displayName = 'SlideCellWrapper'; // 声明displayName，单元测试用于查找组件

    // 2.设定默认值，防止出错
    public static defaultProps = {
        setRef: () => {},
    };

    private disposeShowReaction?: IReactionDisposer;
    private cellInnerRef: SlideListCell | null = null;

    public render() {
        return this.props.slideModel.isSlide ? this.renderSlideListCell() : this.renderLiteSlideListCell();
    }

    public componentDidMount(): void {
        this.disposeShowReaction = reaction(
            () => this.props.slideModel.isShowInPlay,
            () => {
                this.forceUpdate();
            },
        );
    }

    public componentWillUnmount(): void {
        this.disposeShowReaction?.();
    }

    public hiddenContent(hidden: boolean) {
        if (this.cellInnerRef) {
            this.cellInnerRef.setForceHidden(hidden);
        }
    }

    private renderSlideListCell() {
        const { slideWidth, slideHeight, slideModel, isSelected, cellIndex, setRef, renderCellIndex,
            draging, extraClass } = this.props;
        const { key, isShowInPlay } = slideModel as ISlideModel;

        const outerName = classNames(`index-${key}`, {
            [styles.slideOuter]: true,
            'selected-slide': isSelected,
            [extraClass]: true,
        });

        const bgColor = this.getBgColor();

        const style: any = {
            left: 0,
            height: slideHeight,
            padding: 0,
        };
        return (<div
            id={key}
            className={outerName}
            style={{
                ...style,
                // backgroundColor: bgColor
                position: 'relative',
            }}
            onMouseEnter={event => this.props.handleMouseEnter(event, cellIndex)}
            onMouseLeave={event => this.props.handleMouseLeave(event, cellIndex)}
        >
            <div
                style={{
                    width: '180px',
                }}
                onMouseDown={event => this.props.handleMouseDown(event, cellIndex, slideModel)}>
                <SlideListCell
                    isShowInPlay={isShowInPlay}
                    motionStyle={this.props.motionStyle}
                    draging={draging}
                    slideWidth={slideWidth}
                    slideHeight={this.props.slideHeight}
                    slideInnerHeight={this.props.slideInnerHeight}
                    isSelected={isSelected}
                    cellIndex={cellIndex}
                    showSpecialOutline={this.shouldShowSpecialOutline()}
                    shouldContentUpdate={this.props.shouldUpdate}
                    slideModel={slideModel}
                    lockInfo={this.props.lockInfo}
                    clearanceIndex={this.props.clearanceIndex}
                    renderCellIndex={renderCellIndex}
                    ref={(ref) => {
                        setRef('cellRef', ref);
                        this.cellInnerRef = ref;
                    }}
                />
            </div>
            {this.props.renderClearanceOrDragIndicator({
                clearanceIndex: this.props.clearanceIndex,
                selectedClearanceIndex: this.props.slideClearanceIndex,
            })}
        </div>);
    }

    /**
     * 渲染轻量级的幻灯片组件
     * 目前针对与母版编辑列表页渲染
     * @siranxu 功能已逐步对其，之后可以和 renderSlideListCell 合并
     * @returns
     */
    private renderLiteSlideListCell() {
        const { slideWidth, slideHeight, slideModel, isSelected, cellIndex, setRef, extraClass,
            draging, renderCellIndex } = this.props;
        const { key, type, isShowInPlay } = slideModel;

        const outerName = classNames(`index-${key}`, {
            [styles.slideOuter]: true,
            'selected-slide': isSelected && !draging,
            [extraClass]: true,
            [styles.layoutWrapper]: type === UIModelType.LAYOUT,
        });
        const bgColor = this.getBgColor('rgba(255, 255, 255, 0.12)');
        // 母版和版式的间隙大小不一样，故分开写样式
        const clearanceStyle = type === UIModelType.MASTER
            ? { marginTop: -8, height: 15, background: 'unset' }
            : { marginTop: -24, height: 26, background: 'unset' };
        return (<div
            id={key}
            className={outerName}
            style={{
                left: 0,
                height: slideHeight,
                padding: 0,
                position: 'relative',
            }}
        >
            <div
                style={{
                    width: '180px',
                }}
                onMouseDown={event => this.props.handleMouseDown(event, cellIndex, slideModel)}
            >
                <SlideListCell
                    isShowInPlay={isShowInPlay}
                    motionStyle={this.props.motionStyle}
                    draging={draging}
                    slideWidth={slideWidth}
                    slideHeight={slideHeight}
                    slideInnerHeight={this.props.slideInnerHeight}
                    isSelected={isSelected}
                    cellIndex={cellIndex}
                    showSpecialOutline={this.shouldShowSpecialOutline()}
                    shouldContentUpdate={this.props.shouldUpdate}
                    slideModel={slideModel}
                    lockInfo={this.props.lockInfo}
                    renderCellIndex={renderCellIndex}
                    clearanceIndex={this.props.clearanceIndex}
                    ref={(ref) => {
                        setRef('cellRef', ref);
                        this.cellInnerRef = ref;
                    }}
                />
            </div>
            {this.props.renderClearanceOrDragIndicator({
                style: clearanceStyle,
                clearanceIndex: this.props.clearanceIndex,
                selectedClearanceIndex: this.props.slideClearanceIndex,
            })}
        </div>);
    }

    /**
     * 获取选中后的背景色
     */
    private getBgColor(defaultBg = 'rgba(0,0,0,0.08)'): string {
        const { getHistoryColor } = this.props;
        // 修订记录：根据修改作者调整背景色
        let bgColor = getHistoryColor?.();
        if (!bgColor) {
            bgColor = this.shouldShowBg() ? defaultBg : 'transparent';
        }
        return bgColor;
    }


    private shouldShowSpecialOutline() {
        const { isSelected, cellIndex, slideClearanceIndex, draging } = this.props;
        return isSelected
            && !draging
            && (slideClearanceIndex !== cellIndex);
    }

    private shouldShowBg() {
        const { currentDragIndex } = this.props;
        return this.shouldShowSpecialOutline() && currentDragIndex < 0;
    }
}

export default connect(
    CellWrapperPresenter,
    CellWrapperModel,
    SlideCellWrapper,
);
